import { CohortAffinitySkeleton } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/CohortAffinitySkeleton';
import { StyledDivider } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/common.styles';
import { AboutYourCohortSkeleton } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/aboutYourCohortUsersCards/AboutYourCohortSkeleton';
import { ContributingFactorsSkeleton } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/contributingFactorsCards/ContributingFactorsSkeleton';

export const AffinityContentSkeletonId = 'affinity-content-skeleton';

export const AffinityContentSkeleton = () => {
  return (
    <>
      <CohortAffinitySkeleton />
      <StyledDivider />
      <AboutYourCohortSkeleton />
      <ContributingFactorsSkeleton />
    </>
  );
};
